<template>
  <form @submit.prevent="submit" class="needs-validation mb-4">
    <fieldset class="form-group">
      <label for="fname">First Name</label>
      <input v-model="user.fname" type="text" :class="['form-control', { 'is-invalid':validationErrors.fname }]" id="fname" name="fname">
      <div class="invalid-feedback" v-if="validationErrors.fname" v-text="validationErrors.fname"></div>
    </fieldset>
    <fieldset class="form-group">
      <label for="lname">Last Name</label>
      <input v-model="user.lname" type="text" :class="['form-control', { 'is-invalid':validationErrors.lname }]" id="lname" name="lname">
      <div class="invalid-feedback" v-if="validationErrors.lname" v-text="validationErrors.lname"></div>
    </fieldset>
    <fieldset class="form-group">
      <label for="email">Email</label>
      <input v-model="user.email" type="text" :class="['form-control', { 'is-invalid':validationErrors.email }]" id="email" name="email">
      <div class="invalid-feedback" v-if="validationErrors.email" v-text="validationErrors.email"></div>
    </fieldset>
    <div v-if="formStatus.success === true" class="alert alert-success alert-dismissible" role="alert" style="margin-top:20px">
      <p>New user has been created.  They will be receiving an email shortly with instructions on activating their account.</p>
      <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-else-if="formStatus.error === true" class="alert alert-danger alert-dismissible" role="alert" style="margin-top:20px">
      <h4 class="alert-heading" v-html="formStatus.statusHeading"></h4>
      <p v-html="formStatus.statusBody"></p>
      <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <button v-else type="submit" class="btn btn-primary">Add User</button>
  </form>
</template>
<script>
import { mapActions } from 'vuex'
import User from '@/structs/User'

export default {
  name: 'NewUserForm',
  data () {
    return {
      user: new User(),
      validationErrors: {
        fname: null,
        lname: null,
        email: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  created () {
    this.clearForm()
  },
  methods: {
    ...mapActions('user', ['createUser']),
    clearForm () {
      this.user = new User()
      this.clearValidationErrors()
      this.clearFormStatus()
    },
    submit () {
      if (this.validateForm()) {
        this.createUser({ user: this.user })
          .then(newuser => { this.user = newuser; this.$emit('new-user-added', newuser); this.markSuccess() })
          .catch(err => { this.markError(err) })
      }
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to create new user.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      for (var k in this.validationErrors) {
        this.validationErrors[k] = null
      }
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.user.fname || '') === '') {
        this.validationErrors.fname = 'Empty or invalid first name'
        return false
      }

      if ((this.user.lname || '') === '') {
        this.validationErrors.lname = 'Empty or invalid last name'
        return false
      }

      if ((this.user.email || '') === '') {
        this.validationErrors.email = 'Empty or invalid email'
        return false
      }

      return true
    }
  }
}

</script>
